module.exports = __webpack_public_path__ + "img/dash-coin.d0f57aab.svg";